module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "clock-list"
  }, _vm._l((_vm.clockData), function(item, key) {
    return _c('div', {
      key: key,
      staticClass: "clock-item"
    }, [_c('div', {
      staticClass: "bp"
    }, [_c('div', {
      staticClass: "hour",
      style: ('transform: rotateZ(' + item.H_point + 'deg)')
    }), _vm._v(" "), _c('div', {
      staticClass: "min",
      style: ('transform: rotateZ(' + item.M_point + 'deg)')
    }), _vm._v(" "), _c('div', {
      staticClass: "scd",
      style: ('transform: rotateZ(' + item.S_point + 'deg)')
    }), _vm._v(" "), _vm._l((60), function(item) {
      return _c('div', {
        staticClass: "scale",
        style: ('transform: rotateZ(' + 6 * item + 'deg);' + (item % 5 == 0 ? 'height: 15px; width: 2px; ' : ''))
      })
    }), _vm._v(" "), _vm._l((12), function(item) {
      return _c('div', {
        staticClass: "timekey",
        style: ('transform: rotateZ(' + item * 30 + 'deg)')
      }, [_c('div', {
        style: ('transform: rotateZ(' + item * -30 + 'deg)')
      }, [_vm._v(_vm._s(item))])])
    }), _vm._v(" "), _c('p', {
      staticClass: "time-show"
    }, [_vm._v(_vm._s(item.time))])], 2), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.title))])])
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-80209dd4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/clock/clock.vue
// module id = ONDp
// module chunks = 511